import Request from './request'

const SupportInboxEmails = {
  getSupportInboxEmails(params, callback) {
    Request.get('support-inbox-emails/index', params).then(callback).catch(this.bad_answer)
  },
}
export default SupportInboxEmails
